import { useState, useEffect } from 'react';
import Drawer from '../../../../components/v2/Drawer.jsx';

const ReasonDrawer = ({ open, onClose, onSave, saving, globalReasons, nextReasonNumber }) => {
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('');
    const [errors, setErrors] = useState({});

    // Reset form when drawer opens
    useEffect(() => {
        if (open) {
            setDescription('');
            setCategory(globalReasons?.length > 0 ? globalReasons[0].ReasonCodeId : '');
            setErrors({});
        }
    }, [open, globalReasons]);

    const validate = () => {
        const errs = {};
        if (!description.trim()) errs.description = 'Description is required.';
        if (!category) errs.category = 'Category is required.';
        setErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const handleSave = () => {
        if (!validate()) return;
        onSave({ description: description.trim(), category });
    };

    const sorted = [...(globalReasons || [])].sort((a, b) =>
        (a.ReasonDescription || '').localeCompare(b.ReasonDescription || '')
    );

    return (
        <>
            <Drawer
                open={open}
                onClose={onClose}
                title="Add Custom Reason"
                footer={(
                    <>
                        <button className="dp-btn dp-btn--cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button className="dp-btn dp-btn--primary" disabled={saving} onClick={handleSave}>
                            {saving ? 'Adding...' : 'Add Reason'}
                        </button>
                    </>
                )}
            >
                <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', margin: 0 }}>
                    Reason {nextReasonNumber}
                </p>

                <div className="dp-drawer__field">
                    <label className="dp-drawer__label">
                        Description <span className="dp-drawer__required">*</span>
                    </label>
                    <input
                        className={`dp-drawer__input${errors.description ? ' is-invalid' : ''}`}
                        type="text"
                        value={description}
                        placeholder="Enter reason description"
                        onChange={(e) => {
                            setDescription(e.target.value);
                            if (errors.description) setErrors((prev) => ({ ...prev, description: '' }));
                        }}
                    />
                    {errors.description ? (
                        <p className="dp-drawer__error">{errors.description}</p>
                    ) : null}
                </div>

                <div className="dp-drawer__field">
                    <label className="dp-drawer__label">
                        Category <span className="dp-drawer__required">*</span>
                    </label>
                    <select
                        className="dp-drawer__select"
                        value={category}
                        onChange={(e) => {
                            setCategory(e.target.value);
                            if (errors.category) setErrors((prev) => ({ ...prev, category: '' }));
                        }}
                    >
                        {sorted.map((g) => (
                            <option key={g.ReasonCodeId} value={g.ReasonCodeId}>
                                {g.ReasonDescription}
                            </option>
                        ))}
                    </select>
                    {errors.category ? (
                        <p className="dp-drawer__error">{errors.category}</p>
                    ) : null}
                </div>
            </Drawer>
        </>
    );
};

export default ReasonDrawer;
